const STATISTIC_URL = `${window.location.pathname}/measurements`;

export default class Statistic {
  constructor(options = {}) {
    if (!options.fetcher) throw new Error('no Fetcher found');

    this.options = options;
    this.lastPage = false;
    this.signature = null;
  }

  sendClick(promotionsIds) {
    if (!promotionsIds || (promotionsIds.length === 0) || (this.signature === null)) {
      return Promise.resolve(true);
    }

    return this.options.fetcher({
      type: 'POST',
      url: STATISTIC_URL,
      body: JSON.stringify({
        data: {
          clicked: promotionsIds,
        },
      }),
      headers: [
        { 'Content-type': 'application/json; charset=utf-8' },
        { 'Deals-metrics-signature': this.signature },
      ],
    });
  }

  addToView(viewedPromotions, isLastPage) {    
    if ((viewedPromotions.length === 0) || this.lastPage || (this.signature === null)) {
      return Promise.resolve(true);
    }

    return this.options.fetcher({
      type: 'POST',
      url: STATISTIC_URL,
      body: JSON.stringify({
        data: {
          viewed: viewedPromotions,
        },
      }),
      headers: [
        { 'Content-type': 'application/json; charset=utf-8' },
        { 'Deals-metrics-signature': this.signature },
      ],
    }).then(() => {
      if (isLastPage) this.lastPage = true;
    });
  }

  sendWidgetView() {
    return this.options.fetcher({
      type: 'POST',
      url: STATISTIC_URL,
      body: JSON.stringify({
        data: {
          widget_view: 1,
        },
      }),
      headers: [
        { 'Content-type': 'application/json; charset=utf-8' },
        { 'Deals-metrics-signature': this.signature },
      ],
    });
  }
}
